import React from 'react';
import { Divider, Grid } from '@mui/material';
import { CardViewTextRow, CardViewDateRow } from 'ui/viewComponents';
import { isSubscriptionPaymentFailedAction } from '../models/Action';
import { ActionCardBase } from './ActionCardBase';
import { ActionCardModalComponentProps } from './ActionCardModalComponent';
import { getCurrencyString, titleize } from 'lib/helpers';
import { format, isValid } from 'date-fns';

const ActionCardSubscriptionPaymentFailed: React.FC<ActionCardModalComponentProps> = ({ action }) => {
    if (!isSubscriptionPaymentFailedAction(action)) {
        return <ActionCardBase action={action} broken />;
    }

    const {
        subscriptionId,
        subscriptionSchemeId,
        currentBillingPeriodStart,
        currentBillingPeriodEnd,
        paymentMethod,
        subtotal,
        total,
        nextAttemptDate,
        value
    } = action.metadata;

    const billingPeriodStartDate = new Date(currentBillingPeriodStart);
    const billingPeriodEndDate = new Date(currentBillingPeriodEnd);
    const billingPeriodRange =
        isValid(billingPeriodStartDate) && isValid(billingPeriodEndDate)
            ? `${format(billingPeriodStartDate, 'dd/MM/yyyy')} - ${format(
                  billingPeriodEndDate,
                  'dd/MM/yyyy'
              )}`
            : undefined;

    const paymentMethodString = paymentMethod?.lastFour
        ? `${paymentMethod.brand ? `${titleize(paymentMethod.brand)} ` : ''}**** **** **** ${
              paymentMethod.lastFour
          }`
        : undefined;

    return (
        <ActionCardBase action={action} showDate>
            <Grid container spacing={1}>
                <Grid size={6}>
                    <CardViewTextRow title="Subscription ID" value={subscriptionId} noTransform />
                </Grid>
                <Grid size={6}>
                    <CardViewTextRow title="Scheme ID" value={subscriptionSchemeId} noTransform />
                </Grid>

                <Grid size={12}>
                    <Divider />
                </Grid>

                {billingPeriodRange && (
                    <Grid size={paymentMethodString ? 6 : 12}>
                        <CardViewTextRow title="Billing Period" value={billingPeriodRange} />
                    </Grid>
                )}

                {paymentMethodString && (
                    <Grid size={billingPeriodRange ? 6 : 12}>
                        <CardViewTextRow title="Payment Method" value={paymentMethodString} />
                    </Grid>
                )}

                <Grid size={6}>
                    <CardViewTextRow title="Subtotal" value={getCurrencyString(subtotal, value.currency)} />
                </Grid>
                <Grid size={6}>
                    <CardViewTextRow title="Total" value={getCurrencyString(total, value.currency)} />
                </Grid>

                {nextAttemptDate && (
                    <Grid size={12}>
                        <CardViewDateRow title="Next Retry Attempt" value={nextAttemptDate} />
                    </Grid>
                )}
            </Grid>
        </ActionCardBase>
    );
};

export default ActionCardSubscriptionPaymentFailed;
